import React from 'react';
import parse from 'html-react-parser';

const LargeContent = ({content}) => (
  <section className="large-content">
    <div className="large-content__inner">
      {parse(content)}
    </div>
  </section>
);

LargeContent.defaultProps = {
  content: ``,
};

export default LargeContent;